import { Avatar, Group, Menu, Text, UnstyledButton, rem } from '@mantine/core';
import {
    IconChevronDown,
    IconLogout,
    IconSettings,
    IconUser,
} from '@tabler/icons-react';

import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import classes from '../header/Header.module.css';
import cx from 'clsx';
import { useAuthStore } from '../../../store';
import { useState } from 'react';

const user = {
    name: 'Jane Spoonfighter',
    email: 'janspoon@fighter.dev',
    image: 'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-5.png',
};

const UserDropdown = ({ showDropdown }) => {
    const [userMenuOpened, setUserMenuOpened] = useState(false);
    const userProfile = useAuthStore((state) => state.userProfile);
    const logout = useAuthStore((state) => state.logout);

    const handleLogout = () => {
        logout();
    };

    return (
        <Menu
            width={260}
            position='bottom-end'
            transitionProps={{ transition: 'pop-top-right' }}
            onClose={() => setUserMenuOpened(false)}
            onOpen={() => setUserMenuOpened(true)}
            withinPortal>
            <Menu.Target>
                <UnstyledButton
                    className={cx(classes.user, {
                        [classes.userActive]: userMenuOpened,
                    })}>
                    <Group gap={7}>
                        <IconUser
                            size={20}
                            radius={20}
                        />
                        <Text
                            fw={500}
                            size='sm'
                            lh={1}
                            mr={3}>
                            {userProfile?.username}
                        </Text>
                        <IconChevronDown
                            style={{
                                width: rem(12),
                                height: rem(12),
                            }}
                            stroke={1.5}
                        />
                    </Group>
                </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Label>Settings</Menu.Label>
                <Menu.Item
                    component={Link}
                    to={'/settings'}
                    leftSection={
                        <IconSettings
                            style={{
                                width: rem(16),
                                height: rem(16),
                            }}
                            stroke={1.5}
                        />
                    }>
                    Account settings
                </Menu.Item>
                <Menu.Item
                    onClick={handleLogout}
                    leftSection={
                        <IconLogout
                            style={{
                                width: rem(16),
                                height: rem(16),
                            }}
                            stroke={1.5}
                        />
                    }>
                    Logout
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
};
export default UserDropdown;
